import styled from 'styled-components'
import { transitions } from 'polished'
import theme from 'styles/theme'
import { Title60 } from 'components/Typography'

export const ItemList = styled.dl`
  align-items: center;
  color: ${(props) => props.theme.colors.brandPage};
  display: grid;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 10px;

  ${theme.mediaQueries.medium} {
    display: flex;
    margin-top: 50px;
  }

  a {
    ${transitions('border-color ease-in 0.2s')};

    border-bottom: 1px solid transparent;
    text-decoration: none;

    &:hover,
    &:focus {
      border-color: currentColor;
    }
  }
`

export const Item = styled.div`
  padding: ${theme.space[1]};

  dt {
    display: block;
    margin: ${theme.space[2]} 0 ${theme.space[1]};
    text-transform: uppercase;

    ${theme.mediaQueries.medium} {
      display: inline-block;
      margin: 0;
    }
  }

  dd {
    display: block;
    margin: 0;
    padding: 0;

    ${theme.mediaQueries.medium} {
      display: inline-block;
      margin: 0 ${theme.space[1]};
    }
  }

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[1]} ${theme.space[7]};
  }
`

export const ButtonWrapper = styled.div`
  margin-top: ${theme.space[3]};
  text-align: center;

  ${theme.mediaQueries.medium} {
    margin-top: ${theme.space[10]};
  }

  a > span {
    margin-top: 5px;
  }

  a {
    width: 100%;

    ${theme.mediaQueries.small} {
      width: auto;
    }
  }
`

export const Header = styled(Title60)`
  color: ${(props) => props.theme.colors.brandPage};
`
